import _ from 'lodash';
import TextField from '@mui/material/TextField';
import ClearIcon from '@mui/icons-material/Clear';
import { useFormikContext } from 'formik';
import React from 'react';
import { DateTime } from 'luxon'
import styled from 'styled-components';
import { IconButton } from '@mui/material';

const DateRangeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

interface DateRangeProps {
  startAtName: string;
  endAtName: string;
  disabled?: boolean;
  startAt?: string;
  endAt?: string;
}

export const DateRange: React.FC<DateRangeProps> = (props) => {
  const { setFieldValue } = useFormikContext();

  const startAtNum = parseInt(props.startAt || '')
  const endAtNum = parseInt(props.endAt || '')

  const format = 'yyyy-MM-dd\'T\'HH:mm:ss'

  const startAt = startAtNum ? DateTime.fromSeconds(startAtNum).toFormat(format) : undefined
  const endAt = endAtNum ? DateTime.fromSeconds(endAtNum).toFormat(format) : undefined

  return (
    <DateRangeContainer>
      <TextField
        id="date"
        type="datetime-local"
        onChange={(e) => { setFieldValue(props.startAtName, DateTime.fromISO(e.target.value).toSeconds().toString()) }}
        value={startAt || ''}
        sx={{ width: 220 }}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={props.disabled}
      /><span className="dateRangeFrom">〜</span>
      <TextField
        id="date"
        type="datetime-local"
        onChange={(e) => { setFieldValue(props.endAtName, DateTime.fromISO(e.target.value).toSeconds().toString()) }}
        value={endAt || ''}
        sx={{ width: 220 }}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={props.disabled}
      />
      <IconButton aria-label="delete" onClick={(e) => {
        setFieldValue(props.startAtName, '0')
        setFieldValue(props.endAtName, '0')
      }}>
        <ClearIcon />
      </IconButton>
    </DateRangeContainer>
  );
};


export default DateRange